import { Route } from '@angular/router';
import HomeComponent from './pages/home/home.component';
import { ArtGalleryService } from './pages/gallery/art-gallery.service';
import { AppService, getLanguage } from './app.service';
import { DataService } from './data-service';
import { inject, Injector } from '@angular/core';
import NotFoundComponent from './pages/not-found/not-found.component';

import { provideRouteNotfound, provideRouteRedirect, resolverFactory } from '@upupa/common';
import ReadBlogComponent from './pages/read-blog/read-blog.component';
import AboutMeComponent from './pages/about-me/about-me.component';
import GalleryComponent from './pages/gallery/gallery.component';
import ArtBoardViewerComponent from './pages/art-board-viewer/art-board-viewer.component';
import { environment } from '../environments/environment';

export function pageMetaResolver() {
    return {
        content: resolverFactory({ ds: DataService }, async ({ route, ds }) => {
            const language = getLanguage(inject(Injector));
            let path = route.url.join('/');
            if (path === '') path = '/';
            const pageData = await ds.get(`page?path=${path}`).then((r) => r.data?.[0] ?? {});

            // const fallbackPage = pagesData.find((p) => p.path === 'seo-fallback') ?? {};
            // const fallbackMeta = fallbackPage?.seo || {};
            const meta = { ...pageData.seo, ...pageData?.translations?.[language]?.seo };

            meta.type = meta.type || 'website';
            meta.image = meta.image || 'category/paint.jpg';
            meta.twitter ??= {};
            meta.og ??= {};

            meta.twitter['twitter:image'] = meta.twitter['twitter:image'] || meta.image;
            meta.twitter['twitter:card'] = meta.twitter['twitter:card'] || 'summary_large_image';
            meta.og['og:image'] = meta.og['og:image'] || meta.image;

            meta.schema ??= {};
            meta.schema['webPage'] = {
                '@context': 'https://schema.org',
                '@type': 'WebPage',
                name: 'Idris Esen Art',
                description: meta.description,
                url: environment.base_url + `/${language}`,
            };

            meta.schema['localBusiness'] = {
                '@context': 'https://schema.org',
                '@type': 'LocalBusiness',
                name: 'Idris Esen Art',
                description: 'Idris Esen Art',
                image: environment.base_url + '/idrisasen-address.webp',
                address: {
                    '@type': 'PostalAddress',
                    streetAddress: 'Pancarlı Mah. 58007 Sk.',
                    addressLocality: 'Şehitkamil',
                    addressRegion: 'Gaziantep',
                    postalCode: '27000',
                    addressCountry: 'Turkey',
                },
                telephone: '+90 530 426 55 55',
                geo: {
                    '@type': 'GeoCoordinates',
                    // 37°04'00.9"N 37°20'46.7"E
                    // @37.066914,37.346296,17z
                    latitude: 37.066914,
                    longitude: 37.346296,
                },
            };

            return meta;
        }),
    };
}

export function blogResolver() {
    return {
        content: resolverFactory({ app: AppService }, async ({ route, app }) => {
            const slug = route.params['slug'];
            const language = getLanguage(inject(Injector));

            return await app.getBlog(slug, language);
        }),
    };
}

export function artBoardResolver() {
    return {
        content: resolverFactory({ gallery: ArtGalleryService }, async ({ route, gallery }) => {
            const category = route.params['category'];
            const slug = route.params['slug'];
            const filter = route.queryParams['filter'];
            const artboardIdx = await gallery.findIndexOrGetItemBySlug(slug);
            if (gallery.filter !== filter) gallery.change_filter(filter);
            if (gallery.category !== category) gallery.category = category;

            // console.log('artboardIdx', artboardIdx, gallery.all()?.[artboardIdx]);

            return gallery.all()?.[artboardIdx];
        }),
    };
}

// const mainTitle = 'Idris Esen Art';

const homeRoute = {
    path: '',
    pathMatch: 'full',

    component: HomeComponent,
    data: {
        meta: (content) => content,
    },
    resolve: pageMetaResolver(),
} as Route;

const galleryRoute = {
    path: 'gallery/:category',
    component: GalleryComponent,
    data: {
        meta: (content) => content,
    },
    resolve: pageMetaResolver(),
} as Route;

const canvasRoute = {
    path: ':category/canvas/:slug',
    component: ArtBoardViewerComponent,
    data: {
        meta: (content: any) => content.meta,
    },
    resolve: artBoardResolver(),
} as Route;

export const appRoutes: Route[] = [
    homeRoute,
    galleryRoute,
    canvasRoute,
    {
        path: 'art-tales/:slug',
        component: ReadBlogComponent,
        data: {
            meta: (content: any) => content.meta,
        },
        resolve: blogResolver(),
    },
    {
        path: 'about-me',
        component: AboutMeComponent,
        data: {
            meta: (content) => content,
        },
        resolve: pageMetaResolver(),
    },

    provideRouteNotfound({
        path: 'not-found',
        component: NotFoundComponent,
    }),

    // CATCH ALL ------------------------------------------------------
    provideRouteRedirect({
        path: '**',
        redirectTo: '/not-found',
    }),
];
